import React from "react";
import { Section } from "../../../components/section";
import { SectionHeader } from "../../../components/section-header";
import { ParagraphGroup } from "../../../components/paragraph-group";
import { ExternalLink } from "../../../components/external-link";

export interface IntroProps {
	sectionId: string;
	index: number;
}

export function Intro(props: IntroProps) {
	const formattedIndex = props.index > 10 ? props.index : `0${props.index}`;
	return (
		<Section sectionId={props.sectionId} isLast={false}>
			<SectionHeader title={`${formattedIndex} Introduction`} />
			<ParagraphGroup
				title="Building Human AI Collaborative Systems for Misinformation"
				body={[
					"Through our research and design process, we have developed guidelines around the design and implementation of Human-AI collaborative interventions on social platforms. We hope these can serve as a framework for designers, developers data scientists, or platforms seeking to build more robust systems for mitigating the spread of misinformation.",
				]}
			/>
			<ExternalLink
				url="https://infrequent-yuzu-413.notion.site/Implementation-Guidelines-44e6f72e99474f4ea47edd6bac20c4d9"
				cta="View Full Implementation Guidelines"
				solo={true}
			/>
		</Section>
	);
}
